<template>
  <div class="needs-attention-table-cell">
    <span class="body1">
      {{ displayText }}
    </span>
    <el-tooltip placement="right" v-if="displayText === 'Yes'">
      <div slot="content">
        <span style="font-size: 11px; font-weight: 500; line-height: 16px">
          <b>Needs Attention</b><br /><br />
          <span v-if="numProgressions > 0" @click="investigate" class="cursor-pointer">
            Threat Progressions<br />
            <span style="color: #98fbff">Investigate</span>
            <br />
          </span>
          <span v-if="!managed" @click="gotoInstallAgent" class="cursor-pointer">
            Install Agent <br />
            <span style="color: #98fbff">install</span>
            <br />
          </span>
          <span v-else-if="upgradeable" @click="gotoInstallAgent" class="cursor-pointer">
            Agent needs update <br />
            <span style="color: #98fbff">Update</span>
            <br />
          </span>
          <span v-if="status === 'OFFLINE'"> Agent is offline <br /> </span>
        </span>
      </div>
      <i class="display-inline-block" :class="icon"></i>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'NeedsAttentionTableCell',
  props: {
    needsAttention: {
      type: [Boolean]
    },
    protected: {
      type:[String]
    },
    managed: {
      type: [Boolean]
    },
    upgradeable: {
      type: [Boolean]
    },
    numProgressions: {
      type: [Number]
    },
    status: {
      type: [String]
    },
    accountKey: {
      type: [String]
    },
    nickName: {
      type: [String]
    }
  },
  data () {
    return {}
  },
  mounted () {},
  methods: {
    investigate () {
      this.$router.push({
        name: 'account-progressions',
        query: { accountKey: this.accountKey, nickName: this.nickName }
      })
    },
    gotoInstallAgent () {
      this.$router.push({
        name: 'installation',
        params: {}
      })
    }
  },
  computed: {
    displayText () {
      if (this.protected === 'No') {
        return '?'
      } else if (this.needsAttention) {
        return 'Yes'
      } else {
        return 'No'
      }
    },
    styleColor () {
      return '#404c5a'
    },
    icon () {
      if (this.needsAttention) {
        return 'far fa-clipboard-list'
      }
      return ''
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/table/cell/NeedsAttentionTableCell.vue